import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
	{
	  path: '/',
	  name: 'index',
	  component: () => import(/* webpackChunkName: "about" */ '../views/index.vue')
	},
	// {
	//   path: '/index',
	//   name: 'index',
	//   component: () => import(/* webpackChunkName: "about" */ '../views/index.vue')
	// },
	{
	  path: '/newpay',
	  name: 'newpay',
	  component: () => import(/* webpackChunkName: "about" */ '../views/newpay.vue')
	},
	{
	  path: '/alypay',
	  name: 'alypay',
	  component: () => import(/* webpackChunkName: "about" */ '../views/alypay.vue')
	},
	{
	  path: '/btnpay',
	  name: 'btnpay',
	  component: () => import(/* webpackChunkName: "about" */ '../views/btnpay.vue')
	},
	{
	  path: '/outline',
	  name: 'outline',
	  component: () => import(/* webpackChunkName: "about" */ '../views/outline.vue')
	},
	{
	  path: '/success',
	  name: 'success',
	  component: () => import(/* webpackChunkName: "about" */ '../views/success.vue')
	}
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
